import { onUnmounted } from 'vue'

/** Runs finish underneath the page: refresh quietly, in place, the way RunsView's table already does. */
export const DEFAULT_POLL_INTERVAL_MS = 2000

/**
 * Ticks `tick` every `intervalMs` while the tab is visible, and stops on unmount. Mirrors the
 * live-refresh loop RunsView's table already polls with, so every page that refreshes silently
 * in place behaves the same way.
 */
export function useVisiblePolling(tick: () => void, intervalMs: number = DEFAULT_POLL_INTERVAL_MS): void {
    const timer = setInterval(() => {
        if (document.visibilityState !== 'hidden') {
            tick()
        }
    }, intervalMs)

    onUnmounted(() => {
        clearInterval(timer)
    })
}
